const transparent = ({ layout }) => layout?.header?.transparent;

export { transparent };
